import React from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";
import moment from "moment";
import _ from "lodash";
import CustomCheckbox from "components/custom/forms/custom-checkbox";

class Vacation extends React.Component {
    constructor(props) {
        super(props);


        this.handleChangeStatus = this.handleChangeStatus.bind(this);

        this.vocationStatuses = {
            Upcoming: 1,
            Historical: 2
        };

        this.state = {
            currentStatus: this.vocationStatuses.Upcoming
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.currentStatus !== this.state.currentStatus) {
            return true;
        } else if (!_.isEqual(nextProps.vacations, this.props.vacations)) {
            return true;
        }
        return false;
    }

    handleChangeStatus = event => {
        this.setState({
            currentStatus: parseInt(event.target.value, 10)
        });
    };

    render() {
        const { currentStatus } = this.state;
        let vacations = Object.assign([], this.props.vacations);
        vacations = vacations.filter(vacation => (
                (vacation.isUpcoming && currentStatus === this.vocationStatuses.Upcoming)
                ||
                (!vacation.isUpcoming && currentStatus === this.vocationStatuses.Historical)
            ));

        return (
            <div className="mt-3">
                {Array.isArray(this.props.vacations) && this.props.vacations.length ?
                    <div>

                        <div className="d-flex justify-content-center align-items-center mb-3">
                            {Object.keys(this.vocationStatuses).map((statusName) => {
                                const statusId = this.vocationStatuses[statusName];
                                return (
                                    <CustomCheckbox
                                        key={statusId}
                                        id={`vocation-status-${statusId}`}
                                        label={statusName}
                                        type="radio"
                                        checked={currentStatus === statusId}
                                        onChange={this.handleChangeStatus}
                                        value={statusId}
                                        className="mr-5"
                                    />
                                );
                            })}
                        </div>

                        <ReactTable
                            data={vacations}
                            headerClassName="table-header"
                            columns={[{
                                Header: "Type",
                                headerClassName: "text-left",
                                Cell: ({ original }) =>
                                    // moment.weekdays(true, index),
                                    original.type
                            }, {
                                Header: "Dates",
                                headerClassName: "text-left",
                                Cell: ({ original }) => `${moment(original.startDate).format("YYYY-MM-DD")} - ${moment(original.endDate).format("YYYY-MM-DD")}`,
                            }, {
                                Header: "Entered By",
                                headerClassName: "text-left",
                                Cell: ({ original }) => original.enteredBy,
                            }]}
                            defaultPageSize={this.props.vacations.length}
                            className="-striped -highlight"
                            showPagination={false}
                            NoDataComponent={() => null}
                        />
                    </div>
                    :
                    <div className="d-flex mt-4 mb-4 justify-content-center align-content-center text-danger">
                        Vacations Not Set
                    </div>
                }
            </div>
        );
    }
}

Vacation.propTypes = {
    vacations: PropTypes.array.isRequired
};

export default Vacation;
